import { AppliedDiscountInterface, DiscountType as APIDiscountType } from '@vendasta/billing';
import { DiscountType } from '../discount';

export function appliedDiscountTypeFromAPI(adt: APIDiscountType | undefined): DiscountType {
  switch (adt) {
    case APIDiscountType.DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT:
      return DiscountType.FIXED_AMOUNT_PER_UNIT;
    case APIDiscountType.DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS:
      return DiscountType.FIXED_NUMBER_OF_UNITS;
    case APIDiscountType.DISCOUNT_TYPE_PERCENT_AMOUNT:
      return DiscountType.PERCENT_AMOUNT;
  }
  return DiscountType.FIXED_AMOUNT;
}

export function appliedDiscountTypeToApi(adt: DiscountType): APIDiscountType {
  switch (adt) {
    case DiscountType.FIXED_AMOUNT_PER_UNIT:
      return APIDiscountType.DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT;
    case DiscountType.FIXED_NUMBER_OF_UNITS:
      return APIDiscountType.DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS;
    case DiscountType.PERCENT_AMOUNT:
      return APIDiscountType.DISCOUNT_TYPE_PERCENT_AMOUNT;
  }
  return APIDiscountType.DISCOUNT_TYPE_FIXED_AMOUNT;
}

export interface AppliedDiscount {
  type: DiscountType;
  value: number;
  totalAmount: number;
  description: string;
  referenceId: string;
}

export function appliedDiscountFromApi(ad: AppliedDiscountInterface): AppliedDiscount {
  return {
    type: appliedDiscountTypeFromAPI(ad.type),
    value: ad.value || 0,
    totalAmount: ad.totalAmount || 0,
    description: ad.description || '',
    referenceId: ad.referenceId || '',
  };
}

export function appliedDiscountToApi(ad: AppliedDiscount): AppliedDiscountInterface {
  return {
    type: appliedDiscountTypeToApi(ad.type),
    value: ad.value || 0,
    totalAmount: ad.totalAmount || 0,
    description: ad.description || '',
    referenceId: ad.referenceId || '',
  };
}

/** @deprecated use Discount interface from billing/discount */
export interface Discount {
  value: number;
  type: string;
  startDate: Date;
  id?: number;
  endDate?: Date;
  total?: number;
}
